export default __webpack_public_path__ + "static/media/847.fe45f4f3.gif";